module.exports = __webpack_public_path__ + "img/language.1631669a.jpg";